<template>
  <div class="content" id="container">
    <el-row :gutter="20">
      <el-col :span="8">
        <div class="class-manage" :style="{height: tableHeightManage+'px'}">
          <div style="padding:10px;">
            <el-row>
              <el-col :span="22" style="margin-top:12px; margin-bottom:12px;">
                <div class="title-font-style">
                  <span>分类管理</span>
                </div>
              </el-col>
              <el-col :span="2" style="margin-top:12px;">
                <i class="el-icon-circle-plus-outline add-class" @click="onAddClassify"></i>
              </el-col>
            </el-row>
            <el-row style="padding:10px 15px;">
              <el-col :span="24">
                <el-input placeholder="请输入分类名称" v-model.trim="className"></el-input>
              </el-col>
            </el-row>
          </div>
          <div class="class-tree">
            <el-tree
              :expand-on-click-node="false"
              :data="classTree"
              node-key="id"
              ref="classTreeRefs"
              accordion
              :default-expanded-keys="dafaultKeys"
              :filter-node-method="filterNode"
              highlight-current
              @node-click="handleNodeClick"
              :props="defaultProps"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }}</span>
                <el-dropdown @command="handleCommand">
                  <span class="addChildTree">...</span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      command="addChildClass"
                      @click.native="onChildClass(data)"
                      v-show="data.pcLevel!==3"
                    >添加子分类</el-dropdown-item>
                    <el-dropdown-item
                      command="editClass"
                      @click.native="onEditChildClass(data)"
                    >编辑分类</el-dropdown-item>
                    <el-dropdown-item
                      command="disableClass"
                      @click.native="onDisableClass(data)"
                    >{{data.flag?'停用分类':'启用分类'}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </span>
            </el-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="16">
        <div class="class-table">
          <div style="padding:20px 20px  0 20px;">
            <span style="font-weight:600;">当前所选分类：</span>
            {{classification}}
          </div>
          <div class="box-table" :style="{height: tableHeight+'px'}">
            <el-table
              ref="multipleTable"
              :data="productClassData"
              tooltip-effect="dark"
              :header-cell-style="tableHeader"
              :max-height="tableHeight"
              border
            >
              <el-table-column show-overflow-tooltip prop="classOne" label="1级分类"></el-table-column>
              <el-table-column show-overflow-tooltip prop="classTwo" label="2级分类"></el-table-column>
              <el-table-column show-overflow-tooltip prop="classType" label="品类名称"></el-table-column>
              <el-table-column show-overflow-tooltip prop="taxpoint" label="税率">
                <template slot-scope="scope">
                  <div>{{scope.row.taxpoint*100+"%"}}</div>
                </template>
              </el-table-column>
              <el-table-column show-overflow-tooltip prop="editDate" label="最后更新时间">
                <template slot-scope="scope">
                  <div>{{scope.row.editDate|dateFilter}}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-------------- 分页 -------------->
          <div class="pagination">
            <pagination
              :total="total"
              :currentPage="currentPage"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              @handleSizeChange="handleSizeChange"
            ></pagination>
          </div>
        </div>
      </el-col>
    </el-row>
    <!------------ 添加,修改分类 ------------>
    <add-or-edit-class @onRefresh="onRefresh" ref="addOrEditClassRefs"></add-or-edit-class>
    <!-------------- 启用,停用分类 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      :title="title"
      :content="content"
    ></open-or-close>
  </div>
</template>

<script>
import { formatDate } from '@/util/tool'
import { deepClone } from '@/util'
import addOrEditClass from '../dialog/addOrEditClass'
import OpenOrClose from '@/components/OpenOrClose/index'
import pagination from '@/components/pagination'
import {
  queryAllUseProductClassList,
  productClassChangeStateById,
  queryAllProductClassBylevel
} from '@/api/product/productManage'
export default {
  components: {
    'open-or-close': OpenOrClose,
    'add-or-edit-class': addOrEditClass,
    pagination
  },
  watch: {
    className (val) {
      this.$refs.classTreeRefs.filter(val)
    }
  },
  data () {
    return {
      dafaultKeys: [],
      tableHeightManage: window.innerHeight - 140,
      tableHeight: window.innerHeight - 270,
      classTree: [],
      className: '',
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      classification: '全部分类',
      productClassData: [], // 表格数据
      title: '',
      content: '',
      total: 0,
      currentPage: 1,
      pageSize: 30,
      level: 0,
      id: ''
    }
  },
  created () {
    this.height = document.documentElement.clientHeight
    this.getList()
    this.getQueryAllProductClass(
      this.level,
      this.currentPage,
      this.pageSize,
      this.id
    )
  },
  methods: {
    onRefresh (queryParams, typeAddOrEdit) {
      this.classification = '全部分类'
      if (typeAddOrEdit === 'edit') {
        if (queryParams.level === 2) {
          this.classTree.forEach(element => {
            element.children.forEach(ele => {
              if (ele.id === queryParams.id) {
                this.getList(element.id)
              }
            })
          })
        } else if (queryParams.level === 3) {
          this.getList(queryParams.id)
        } else {
          this.getList()
        }

        this.currentPage = 1
        this.getQueryAllProductClass(
          0,
          this.currentPage,
          this.pageSize,
          ''
        )
      } else {
        console.log(1111111, queryParams.id)
        this.currentPage = 1
        this.getList(queryParams.id)
        this.getQueryAllProductClass(
          0,
          this.currentPage,
          this.pageSize,
          ''
        )
      }

      // this.classificationList(this.level, this.id)
    },
    classificationList (pcLevel, id) {
      if (pcLevel === 1) {
        this.classTree.forEach(element => {
          if (element.id === id) {
            this.classification = element.label
          }
        })
      } else if (pcLevel === 2) {
        this.classTree.forEach(element => {
          if (element.children !== '') {
            element.children.forEach(ele => {
              if (ele.id === id) {
                this.classification = element.label + ' / ' + ele.label
              }
            })
          }
        })
      } else if (pcLevel === 3) {
        this.classTree.forEach(element => {
          if (element.children !== '') {
            element.children.forEach(ele => {
              if (ele.children !== '') {
                ele.children.forEach(data => {
                  if (data.id === id) {
                    this.classification = element.label + ' / ' + ele.label + ' / ' + data.label
                  }
                })
              }
            })
          }
        })
      }
    },
    // 获取右侧列表
    getQueryAllProductClass (level, currentPage, pageSize, id) {
      queryAllProductClassBylevel(level, currentPage, pageSize, id)
        .then((res) => {
          if (res.data.code === 200) {
            this.productClassData = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取分类接口
    getList (id) {
      queryAllUseProductClassList()
        .then((res) => {
          if (res.data.code === 200) {
            this.classTree = this.$ConTree(
              res.data.obj,
              'id',
              'fid',
              'children'
            )
            this.classTree = deepClone(this.classTree)

            if (id) {
              this.dafaultKeys = [id]
            } else {
              this.dafaultKeys = []
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 点击节点触发的事件
    handleNodeClick (data) {
      this.currentPage = 1
      this.pageSize = 30
      this.getQueryAllProductClass(
        data.pcLevel,
        this.currentPage,
        this.pageSize,
        data.id
      )
      this.classificationList(data.pcLevel, data.id)
    },
    filterNode (value, data) {
      if (!value) return true
      return data.label.indexOf(value) !== -1
    },
    // 添加一级分类
    onAddClassify () {
      this.$refs.addOrEditClassRefs.onInitialize(0, '', 'add')
    },
    // 添加子分类
    onChildClass (data) {
      this.$refs.addOrEditClassRefs.onInitialize(data.pcLevel, data, 'add')
    },
    // 编辑子分类
    onEditChildClass (data) {
      this.$refs.addOrEditClassRefs.onInitialize(data.pcLevel, data, 'edit')
    },
    // 表头样式
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    handleCommand (command) {
      this.command = command
    },
    // 停用启用状态
    onDisableClass (data) {
      if (!data.flag) {
        this.title = '启用'
        this.content = '确定启用该分类？'
      } else {
        this.content = '确定停用该分类？'
        this.title = '停用'
      }
      this.$refs.OpenOrCloseRefs.onInitial(data)
    },
    // 修改分类状态
    onUpdataState (params) {
      productClassChangeStateById(!params.flag, params.id)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(params.flag ? '该分类已停用' : '该分类已启用')
            this.getList()
            this.classification = '全部分类'
            this.currentPage = 1
            this.pageSize = 30
            this.getQueryAllProductClass(
              0,
              this.currentPage,
              this.pageSize,
              ''
            )
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val

      this.getList()
      this.getQueryAllProductClass(
        this.level,
        this.currentPage,
        this.pageSize,
        this.id
      )
      this.classificationList(this.level, this.id)
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1

      this.getList()
      this.getQueryAllProductClass(
        this.level,
        this.currentPage,
        this.pageSize,
        this.id
      )
      this.classificationList(this.level, this.id)
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  if (time === null) {
    return ''
  } else {
    const date = new Date(time)
    return formatDate(date, 'yyyy-MM-dd hh:mm')
  }
}
</script>

<style lang="scss" scoped>
.el-col {
  height: 100%;
}
.el-breadcrumb {
  line-height: 28px;
}
::v-deep .el-form-item--mini.el-form-item,
::v-deep .el-form-item--small.el-form-item {
  margin-bottom: 14px;
}
::v-deep .el-tree-node__content {
  position: relative;
  .el-dropdown {
    position: absolute;
    right: 20px;
  }
}
.class-table {
  background-color: white;
  // height: 790px;
}
</style>
